if (!customElements.get("product-mini-complementary-slider")) {
  class ProductMiniComplementarySlider extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === "true") return;
      this.dataset.initialized = "true";

      this.track = this.querySelector(".product__mini-complementary-track");
      if (!this.track) return;

      this.dragging = false;
      this.suppressClick = false;
      this.startX = 0;
      this.startScrollLeft = 0;
      this.activePointerId = null;

      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onDragStart = this.onDragStart.bind(this);
      this.onScroll = this.onScroll.bind(this);

      this.track.addEventListener("pointerdown", this.onPointerDown);
      this.track.addEventListener("pointermove", this.onPointerMove);
      this.track.addEventListener("pointerup", this.onPointerUp);
      this.track.addEventListener("pointercancel", this.onPointerUp);
      this.track.addEventListener("click", this.onClick, true);
      this.track.addEventListener("dragstart", this.onDragStart);
      this.track.addEventListener("scroll", this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      if (!this.track) return;

      this.track.removeEventListener("pointerdown", this.onPointerDown);
      this.track.removeEventListener("pointermove", this.onPointerMove);
      this.track.removeEventListener("pointerup", this.onPointerUp);
      this.track.removeEventListener("pointercancel", this.onPointerUp);
      this.track.removeEventListener("click", this.onClick, true);
      this.track.removeEventListener("dragstart", this.onDragStart);
      this.track.removeEventListener("scroll", this.onScroll);
    }

    onPointerDown(event) {
      if (event.pointerType === "mouse" && event.button !== 0) return;

      this.dragging = true;
      this.hasMoved = false;
      this.suppressClick = false;
      this.startX = event.clientX;
      this.startScrollLeft = this.track.scrollLeft;
      this.activePointerId = event.pointerId;
    }

    onPointerMove(event) {
      if (!this.dragging) return;

      const deltaX = event.clientX - this.startX;
      if (Math.abs(deltaX) > 4) {
        if (!this.hasMoved) {
          this.hasMoved = true;
          this.track.classList.add("is-dragging");
          try {
            this.track.setPointerCapture?.(event.pointerId);
          } catch (error) {
            // Pointer capture is a convenience for dragging outside the row;
            // scrolling must still work when the browser refuses capture.
          }
        }
        event.preventDefault();
      }

      this.track.scrollLeft = this.startScrollLeft - deltaX;
    }

    onPointerUp(event) {
      if (!this.dragging) return;

      this.dragging = false;
      this.suppressClick = this.hasMoved;
      this.track.classList.remove("is-dragging");
      if (
        this.hasMoved &&
        this.activePointerId !== null &&
        this.track.hasPointerCapture?.(this.activePointerId)
      ) {
        try {
          this.track.releasePointerCapture(this.activePointerId);
        } catch (error) {
          // Ignore stale pointer capture state.
        }
      }
      this.activePointerId = null;
    }

    onClick(event) {
      if (!this.suppressClick) return;

      event.preventDefault();
      event.stopPropagation();
      this.suppressClick = false;
    }

    onDragStart(event) {
      event.preventDefault();
    }

    onScroll() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const progress = maxScroll > 0 ? this.track.scrollLeft / maxScroll : 0;
      this.style.setProperty(
        "--pdp-mini-scroll-thumb-offset",
        `${Math.round(progress * 210)}px`,
      );
    }
  }

  customElements.define(
    "product-mini-complementary-slider",
    ProductMiniComplementarySlider,
  );
}
